module.exports = __webpack_public_path__ + "static/media/setting-icon.b42cdbef.svg";